import { resolveMediaUrl } from "../config/api";

export function optimizeCloudinaryUrl(url, width = 1200) {
  if (!url) return url;
  const pathStr = resolveMediaUrl(String(url));
  if (!pathStr.includes("res.cloudinary.com") || !pathStr.includes("/upload/")) {
    return pathStr;
  }
  if (pathStr.includes("/upload/f_auto") || pathStr.includes("/upload/c_")) {
    return pathStr;
  }
  return pathStr.replace("/upload/", `/upload/f_auto,q_auto,w_${width}/`);
}
